/**
 * Kennungen: Aktionskennung aus Muster (Plan 01 Abschnitt 6.7).
 * Umlaute bleiben erhalten, weil die bestehenden Kennungen sie enthalten (PFM261103_Beiersdorf_Töpsheide).
 */
export function codePart(s: string): string {
  return String(s ?? '')
    .replace(/\s+AG$|\s+GmbH$|\s+e\.?\s?V\.?$/i, '')
    .replace(/[^0-9A-Za-zÄÖÜäöüß]+/g, '')
    .slice(0, 40);
}
export function yymmdd(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${(y ?? '').slice(2)}${m ?? ''}${d ?? ''}`;
}
export function buildCode(
  pattern: string,
  vars: { prefix: string; date: string; partner: string; ort: string },
): string {
  return pattern
    .replace('{prefix}', vars.prefix)
    .replace('{yymmdd}', yymmdd(vars.date))
    .replace('{partner}', codePart(vars.partner))
    .replace('{ort}', codePart(vars.ort));
}
/** Eindeutigkeit: bei Kollision Suffix _2, _3 … */
export function uniqueCode(base: string, exists: (c: string) => boolean): string {
  if (!exists(base)) return base;
  let i = 2;
  while (exists(`${base}_${i}`)) i++;
  return `${base}_${i}`;
}
